/**
 * 基础选择框组件 后面可能废弃
 */
import Vue from 'vue';
import PluginsTemplate from '../pluginsTemplate';

import baseSlideSelect from 'components/base-ui/base-slide-select/index';
const baseSlideSelectConstructor = Vue.extend(baseSlideSelect);

class BaseSlideSelectPlugin extends PluginsTemplate {
  constructor() {
    super();
    this.defaults = {
      showPopup: true,
      comparedKey: 'key',
      showKey: 'value',
    };
  }
  show(options) {
    this.clearTimer();
    this.initPros(options);
    // 如果不存在实例 则初始化实例
    if (!this.instance) {
      let newInstance = new baseSlideSelectConstructor({
        el: document.createElement('div'),
      });
      this.initInstance(newInstance);
    }
    // 初始化节点
    this.initDom();
  }
  initMethods() {
    this.instance.$off('select-item');
    this.instance.$on('select-item', (result) => {
      this.props.selectHandle && this.props.selectHandle(result);
    });
    this.instance.$off('cancel-select');
    this.instance.$on('cancel-select', (result) => {
      this.close();
      this.props.closeHandle && this.props.closeHandle(result);
    });
  }
  close() {
    if (!this.instance) {
      return !1;
    }
    this.instance.showPopup = false;
    // 解决点击过快的话会有问题
    this.clearTimer();
    this.timer = setTimeout(() => {
      this.removeInstance();
    }, 500);
  }
}

let instance = new BaseSlideSelectPlugin();
export default {
  show(options) {
    instance.show(options);
    return instance;
  },
  close() {
    instance.close();
  },
  install() {
    instance.install();
  },
};
